import { useState } from "react";

export default function CompanyDetailModal({
  selectedCompany,
  setSelectedCompany,
  setSelectedProject,
  setEditProject,
  getKalanAyNumber,
  calculateKalanAySureForProject
}) {
  const projeler = selectedCompany?.projeler || [];
  const [projectFilter, setProjectFilter] = useState("all");

  const aktifProjeler = projeler.filter((p) => !p.sonlandirmaTarihi);

  const riskliProjeler = projeler.filter((p) => {
    const kalan = getKalanAyNumber(p);
    return kalan !== null && kalan >= 0 && kalan <= 90;
  });

  const kritikProjeler = projeler.filter((p) => {
    const kalan = getKalanAyNumber(p);
    return kalan !== null && kalan < 0;
  });

  const bitirmeBekleyenler = projeler.filter(
    (p) =>
      !p.projeBitirmeBelgesi ||
      p.projeBitirmeBelgesi === "Yok" ||
      p.projeBitirmeBelgesi === "Kontrol Edilecek"
  );

  const tescilBekleyenler = projeler.filter(
    (p) => p.projeKategorisi === "Yazılım" && p.yazilimTescilBelgesi !== "Var"
  );

  const degerlendirmeBekleyenler = selectedCompany.projeler.filter(
  (p) => String(p.projeStbKodu || "").trim().toUpperCase() === "DB"
    );

    const firmaSaglikPuani = Math.max(
      100 -
        kritikProjeler.length * 25 -
        riskliProjeler.length * 10 -
        bitirmeBekleyenler.length * 5 -
        tescilBekleyenler.length * 5 -
        (selectedCompany.sonlandirilanProjeSayisi || 0) * 2 -
        degerlendirmeBekleyenler.length * 3,
      0
    );

    const firmaSaglikDurumu =
      firmaSaglikPuani < 60
        ? { label: "Kritik", icon: "🔴", background: "#fee2e2", color: "#991b1b" }
        : firmaSaglikPuani < 80
        ? { label: "Takip Edilmeli", icon: "🟠", background: "#fef3c7", color: "#92400e" }
        : { label: "Sağlıklı", icon: "🟢", background: "#dcfce7", color: "#166534" };

  const siraliProjeler = [...projeler].sort((a, b) => {
    const aGun = getKalanAyNumber(a);
    const bGun = getKalanAyNumber(b);

    const aRisk = aGun === null ? 9999 : aGun < 0 ? -2 : aGun <= 90 ? -1 : aGun;
    const bRisk = bGun === null ? 9999 : bGun < 0 ? -2 : bGun <= 90 ? -1 : bGun;

    return aRisk - bRisk;
  });

  const filtreliProjeler = siraliProjeler.filter((project) => {
  const kalan = getKalanAyNumber(project);

  if (projectFilter === "aktif") return !project.sonlandirmaTarihi;
  if (projectFilter === "riskli") return kalan !== null && kalan >= 0 && kalan <= 90;
  if (projectFilter === "kritik") return kalan !== null && kalan < 0;
  if (projectFilter === "sonlandirilan") return Boolean(project.sonlandirmaTarihi);

  if (projectFilter === "bitirme") {
    return (
      !project.projeBitirmeBelgesi ||
      project.projeBitirmeBelgesi === "Yok" ||
      project.projeBitirmeBelgesi === "Kontrol Edilecek"
    );
  }

  if (projectFilter === "tescil") {
    return project.projeKategorisi === "Yazılım" && project.yazilimTescilBelgesi !== "Var";
  }

  return true;
  });

  const getProjectCardStyle = (project) => {
    const kalan = getKalanAyNumber(project);

    if (kalan !== null && kalan < 0) {
      return {
        border: "1px solid #fca5a5",
        borderLeft: "6px solid #ef4444",
        background: "#fff5f5"
      };
    }

    if (kalan !== null && kalan <= 90) {
      return {
        border: "1px solid #facc15",
        borderLeft: "6px solid #f59e0b",
        background: "#fffbea"
      };
    }

    return {
      border: "1px solid #e5e7eb",
      borderLeft: "6px solid #94a3b8",
      background: "#f9fafb"
    };
  };

  const getProjectStatusText = (project) => {
    const kalan = getKalanAyNumber(project);

    if (project.projeStbKodu?.toString().toUpperCase() === "DB") {
      return {
        text: "Değerlendirme Bekliyor",
        background: "#e0f2fe",
        color: "#075985"
      };
    }

    if (kalan !== null && kalan < 0) {
      return {
        text: "Süresi Geçmiş",
        background: "#fee2e2",
        color: "#991b1b"
      };
    }

    if (kalan !== null && kalan <= 90) {
      return {
        text: "Yaklaşan",
        background: "#fef3c7",
        color: "#92400e"
      };
    }

    if (project.sonlandirmaTarihi) {
      return {
        text: "Sonlandırılmış",
        background: "#f1f5f9",
        color: "#475569"
      };
    }

    return {
      text: "Stabil",
      background: "#dcfce7",
      color: "#166534"
    };
  };

  const summaryCards = [
    {
      title: "Toplam Proje",
      value: selectedCompany.projeSayisi || projeler.length,
      bg: "#eef4ff",
      color: "#124254"
    },
    {
      title: "Aktif Proje",
      value: aktifProjeler.length,
      bg: "#dcfce7",
      color: "#166534"
    },
    {
      title: "Sonlandırılan",
      value: selectedCompany.sonlandirilanProjeSayisi || 0,
      bg: "#fee2e2",
      color: "#991b1b"
    },
    {
      title: "Riskli Proje",
      value: riskliProjeler.length,
      bg: "#fff7d6",
      color: "#92400e"
    },
    {
      title: "Kritik Proje",
      value: kritikProjeler.length,
      bg: "#fee2e2",
      color: "#991b1b"
    },
    {
      title: "Bitirme Bekleyen",
      value: bitirmeBekleyenler.length,
      bg: "#fff7ed",
      color: "#9a3412"
    },
    {
      title: "Tescil Bekleyen",
      value: tescilBekleyenler.length,
      bg: "#ede9fe",
      color: "#6d28d9"
    },
  ];

  return (
    <div
      onClick={() => setSelectedCompany(null)}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.55)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        padding: 24
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#fff",
          padding: 32,
          borderRadius: 22,
          width: "92%",
          maxWidth: 1050,
          maxHeight: "88vh",
          overflowY: "auto",
          boxShadow: "0 30px 80px rgba(0,0,0,0.25)"
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: 16,
            borderBottom: "1px solid #eee",
            paddingBottom: 16,
            marginBottom: 20
          }}
        >
          <div>
            <h2 style={{ margin: 0, color: "#124254" }}>{selectedCompany.firmaAdi}</h2>
            <p style={{ marginTop: 8, color: "#666" }}>Firma bazlı proje, personel ve belge özeti</p>
          </div>

          <button
            type="button"
            onClick={() => setSelectedCompany(null)}
            style={{
              border: "none",
              background: "#f3f4f6",
              width: 38,
              height: 38,
              borderRadius: 12,
              fontSize: 24,
              cursor: "pointer",
              color: "#374151"
            }}
          >
            ×
          </button>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(170px, 1fr))",
            gap: 14,
            marginBottom: 20
          }}
        >
          {summaryCards.map((card) => (
            <div
              key={card.title}
              style={{
                background: card.bg,
                padding: 16,
                borderRadius: 14
              }}
            >
              <div style={{ color: card.color, fontSize: 13, fontWeight: 700 }}>{card.title}</div>
              <strong style={{ fontSize: 26, color: "#111827" }}>{card.value}</strong>
            </div>
          ))}
        </div>

        <div
          style={{
            marginBottom: 24,
            padding: 18,
            borderRadius: 18,
            background: firmaSaglikDurumu.background,
            border: "1px solid #e5e7eb"
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 12 }}>
            <div>
              <div style={{ fontWeight: 800, color: firmaSaglikDurumu.color }}>
                Firma Sağlık Karnesi
              </div>
              <div style={{ fontSize: 30, fontWeight: 900 }}>
                {firmaSaglikPuani} / 100
              </div>
            </div>

            <div
              style={{
                padding: "9px 13px",
                borderRadius: 999,
                background: "#fff",
                color: firmaSaglikDurumu.color,
                fontWeight: 900,
                height: "fit-content"
              }}
            >
              {firmaSaglikDurumu.icon} {firmaSaglikDurumu.label}
            </div>
          </div>

          <div
            style={{
              height: 10,
              borderRadius: 999,
              background: "rgba(255,255,255,0.75)",
              overflow: "hidden"
            }}
          >
            <div
              style={{
                width: `${firmaSaglikPuani}%`,
                height: "100%",
                background: firmaSaglikDurumu.color
              }}
            />
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 12,
            marginBottom: 14
          }}
        >
          <h3 style={{ margin: 0, color: "#124254" }}>Projeler</h3>
          <span style={{ color: "#6b7280", fontSize: 13, fontWeight: 700 }}>
            Risk durumuna göre sıralandı
          </span>
        </div>

         <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 16 }}>
          {[
            { key: "all", label: `Tümü (${siraliProjeler.length})` },
            { key: "aktif", label: `Aktif (${aktifProjeler.length})` },
            { key: "riskli", label: `Riskli (${riskliProjeler.length})` },
            { key: "kritik", label: `Kritik (${kritikProjeler.length})` },
            { key: "sonlandirilan", label: `Sonlandırılan (${selectedCompany.sonlandirilanProjeSayisi || 0})` },
            { key: "bitirme", label: `Bitirme (${bitirmeBekleyenler.length})` },
            { key: "tescil", label: `Tescil (${tescilBekleyenler.length})` }
          ].map((filter) => (
            <button
              key={filter.key}
              type="button"
              onClick={() => setProjectFilter(filter.key)}
              style={{
                border: "1px solid #e5e7eb",
                background: projectFilter === filter.key ? "#124254" : "#f9fafb",
                color: projectFilter === filter.key ? "#fff" : "#124254",
                padding: "8px 11px",
                borderRadius: 999,
                fontSize: 13,
                fontWeight: 800,
                cursor: "pointer"
              }}
            >
              {filter.label}
            </button>
          ))}
        </div>

        <div style={{ display: "grid", gap: 12 }}>
          {filtreliProjeler.length === 0 ? (
            <div
              style={{
                padding: 18,
                borderRadius: 14,
                background: "#f9fafb",
                color: "#6b7280",
                fontWeight: 700
              }}
            >
              Bu firmaya ait proje bulunmuyor.
            </div>
          ) : (
            filtreliProjeler.map((project) => {
              const cardStyle = getProjectCardStyle(project);
              const status = getProjectStatusText(project);

              return (
                <div
                  key={project.id}
                  onClick={() => {
                    setSelectedProject(project);
                    setEditProject(project);
                    setSelectedCompany(null);
                  }}
                  style={{
                    padding: 16,
                    borderRadius: 14,
                    ...cardStyle,
                    cursor: "pointer",
                    transition: "0.2s ease"
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      gap: 12
                    }}
                  >
                    <div>
                      <strong style={{ fontSize: 15 }}>{project.projeAdi || "Proje adı yok"}</strong>

                      <div style={{ marginTop: 6, color: "#555", fontSize: 14 }}>
                        STB: {project.projeStbKodu || "-"} | Teknopark: {project.teknoparkAdi || "-"}
                      </div>
                    </div>

                    <span
                      style={{
                        padding: "6px 10px",
                        borderRadius: 999,
                        background: status.background,
                        color: status.color,
                        fontSize: 12,
                        fontWeight: 800,
                        whiteSpace: "nowrap"
                      }}
                    >
                      {status.text}
                    </span>
                  </div>

                  <div style={{ marginTop: 10, display: "flex", flexWrap: "wrap", gap: 8 }}>
                    <InfoBadge bg="#eef4ff" color="#124254">
                      👥 Personel: {project.onayliPersonelSayisiToplam || 0}
                    </InfoBadge>

                    <InfoBadge bg="#eff6ff" color="#2563eb">
                      Ar-Ge: {project.argePersoneli || 0}
                    </InfoBadge>

                    <InfoBadge bg="#ecfdf5" color="#059669">
                      Yazılım: {project.yazilimPersoneli || 0}
                    </InfoBadge>

                    <InfoBadge bg="#fff7ed" color="#d97706">
                      Destek: {project.destekPersoneli || 0}
                    </InfoBadge>

                    <InfoBadge bg="#fff7d6" color="#92400e">
                      ⏳ {calculateKalanAySureForProject(project)}
                    </InfoBadge>

                    <InfoBadge bg="#f8fafc" color="#475569">
                      Bitirme: {project.projeBitirmeBelgesi || "-"}
                    </InfoBadge>

                    {project.projeKategorisi === "Yazılım" && (
                      <InfoBadge bg="#f5f3ff" color="#6d28d9">
                        Tescil: {project.yazilimTescilBelgesi || "-"}
                      </InfoBadge>
                    )}
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
}

function InfoBadge({ children, bg, color }) {
  return (
    <span
      style={{
        padding: "6px 10px",
        borderRadius: 999,
        background: bg,
        color,
        fontSize: 13,
        fontWeight: 700
      }}
    >
      {children}
    </span>
  );
}